<div [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'root-body-horizontal': configService.config.menuMode === 'horizontal'}">
	<div class="flex">
		<div>
			<sidebar-menu (changedGeoZoneEmit)="changedGeoZoneEmit($event)">
				<div class="sidebar-title">
					<hr />
					<div>Support</div>
				</div>

				<hr class="sidebar-hr" />

				<div class="sidebar-body">
					<div class="sidebar-block-link">
						<a [ngClass]="{'active': activeMenu === menuEnum.Drivers}"
						   (click)="handleSideMenuClick(menuEnum.Drivers)">Drivers support</a>
					</div>
					<div class="sidebar-block-link">
						<a [ngClass]="{'active': activeMenu === menuEnum.Customers}"
						   (click)="handleSideMenuClick(menuEnum.Customers)">Customers support</a>
					</div>
				</div>
			</sidebar-menu>
		</div>
		<div class="sidebar-next-right-block">
			<xpress-topbar style="width: 100vw; display: block; margin-bottom: 20px;"></xpress-topbar>

			<support-drivers *ngIf="activeMenu === menuEnum.Drivers"></support-drivers>
			<support-customers *ngIf="activeMenu === menuEnum.Customers"></support-customers>
		</div>
	</div>
</div>
